import React from "react"

import { Symbols } from "@tenforce/toolbox-fontmap"

import { ICheckListViewActions, IOption, IQuestion } from "../../.."

export interface Props extends IQuestion {
    contextMenuActions: ICheckListViewActions
}

export const PickerValue = ({
    data,
    type,
    id,
    contextMenuActions: { updateOptionValue },
}: Props): JSX.Element => {
    const isSingleSelect = type === "SinglePicker"
    const parsedOptions = data as IOption[]
    return (
        <div
            data-ft-component="pickerOptionContainer"
            data-ft-count={parsedOptions.length}
            data-ft-is-single-picker={isSingleSelect}
            className="tw-w-1/3"
        >
            {parsedOptions.map((option) => (
                <button
                    key={option.id}
                    data-ft-component="pickerOption"
                    data-ft-id={option.id}
                    data-ft-is-selected={option.isSelected}
                    data-ft-title={option.label}
                    onClick={(): void => {
                        updateOptionValue(id, option.id, !option.isSelected)
                    }}
                    className="theme-thumb theme-thumb--wide bg-cloud tw-flex tw-mx-0"
                >
                    <span className="tw-flex-1">{option.label}</span>
                    <span className="text-action">
                        {isSingleSelect && option.isSelected && (
                            <>{Symbols.Confirm}</>
                        )}

                        {!isSingleSelect && option.isSelected && (
                            <>{Symbols.CircleCheck}</>
                        )}

                        {!isSingleSelect && !option.isSelected && (
                            <>{Symbols.Circle}</>
                        )}
                    </span>
                </button>
            ))}
        </div>
    )
}

export default PickerValue
